const modalConfirm = document.getElementById("modalConfirm");
const modalConfirmBackdrop = document.getElementById("modalConfirmBackdrop");
const modalConfirmTitle = document.getElementById("modalConfirmTitle");
const modalConfirmDescription = document.getElementById("modalConfirmDescription");
const modalConfirmNo = document.getElementById("modalConfirmNo");
const modalConfirmYes = document.getElementById("modalConfirmYes");

const closeModalCancelTriggers = document.getElementsByClassName("close-modal-trigger");
const closeModalConfirmTriggers = document.getElementsByClassName("confirm-modal-trigger");

let confirmModalOpen = false;
let isTogglingConfirmModalOpen = false;
let onConfirmModalFunction = null;

const transitionDuration = 300;


const setModelOpen = (targetModal, targetBackdrop, shouldBeOpen) => {
  if (!targetModal || !targetBackdrop || isTogglingConfirmModalOpen) return;

  confirmModalOpen = shouldBeOpen;
  isTogglingConfirmModalOpen = true;

  setTimeout(() => isTogglingConfirmModalOpen = false, transitionDuration);

  if (shouldBeOpen) {
    targetModal.classList.remove("hidden");
    setTimeout(() => {
      if (!confirmModalOpen) return;
      targetModal.classList.remove("opacity-0");
      targetBackdrop.classList.remove("opacity-0");
      targetModal.querySelector("button, a, input, select, textarea").focus();
    }, 25); // Requires at least 1 render cycle
  } else {
    targetModal.classList.add("opacity-0");
    setTimeout(() => {
      if (confirmModalOpen) return;
      targetModal.classList.add("hidden");
      targetModal.classList.add("opacity-0");
      targetBackdrop.classList.add("opacity-0");
    }, transitionDuration);
  }
};

for (let i = 0; i < closeModalCancelTriggers.length; i++) {
  closeModalCancelTriggers[i].addEventListener("click", () => setModelOpen(modalConfirm, modalConfirmBackdrop, false));
}

for (let i = 0; i < closeModalConfirmTriggers.length; i++) {
  closeModalConfirmTriggers[i].addEventListener("click", () => {
    if (onConfirmModalFunction) onConfirmModalFunction();
    setModelOpen(modalConfirm, modalConfirmBackdrop, false);
  });
}

export const showModalConfirm = (title, description, onConfirm, yesCopy = "Confirm", noCopy = "Cancel", foregroundHex= "", backgroundHex = "") => {
  modalConfirmTitle.innerText = title;
  modalConfirmDescription.innerText = description;
  modalConfirmYes.innerText = yesCopy;
  modalConfirmNo.innerText = noCopy;
  modalConfirmYes.style.color = foregroundHex;
  modalConfirmYes.style.backgroundColor = backgroundHex;
  onConfirmModalFunction = onConfirm;

  setModelOpen(modalConfirm, modalConfirmBackdrop, true);
};
